// @flow

import type { PropsSchema, BasicProps } from '../../type'

import * as React from 'react'
import css from './Popup.scss'
import onClickEvents from '../hoc/onClickEvent'
import computeData from '../hoc/computeData'
import animation from '../hoc/animation'

type Props = BasicProps & {
  style: { [string]: string },
  children: React.ChildrenArray<React.Node>,
  showOverlay?: boolean,
  onClick: () => void,
  opacity: number,
  addAnimationEvent: any => void
};

type State = {
  style?: { [string]: string }
};

@computeData({ includeData: true })
@animation
@onClickEvents
export default class Fixed extends React.PureComponent<Props, State> {
  static schema: PropsSchema = [
    {
      type: 'boolean',
      key: 'showOverlay',
      title: '显示蒙层'
    },
    {
      type: 'number',
      key: 'opacity',
      title: '透明度',
      visible: p => p.showOverlay
    },
    {
      type: 'event',
      title: '点击蒙层',
      event: 'onClickOverlay',
      visible: p => p.showOverlay
    },
    'separator',
    {
      type: 'style',
      group: 'absolutePosition'
    }
  ];

  static defaultProps = {
    showOverlay: false
  };

  elementMap: { [string]: ?HTMLElement } = {};
  height: number;

  updateElement = (name: string, element: ?HTMLElement) => {
    const containerElement = document.getElementById('easy-comp-container')
    if (containerElement) {
      if (element) {
        this.elementMap[name] = element
        containerElement.appendChild(element)
        // 添加动画
        let { addAnimationEvent } = this.props
        if (element && addAnimationEvent) {
          addAnimationEvent(element)
        }
      } else if (this.elementMap[name]) {
        containerElement.removeChild(this.elementMap[name])
      }
    }
  };
  clickOverlay = () => {
    this.props.callActions('onClickOverlay')
  };

  render () {
    if (!this.props.visible) {
      return null
    }
    const { id, children, onClick, showOverlay, style, opacity } = this.props
    const overlayStyle = {
      background: `rgba(0, 0, 0, ${opacity || 0.4})`,
      zIndex: style.zIndex
    }
    return (
      <div>
        {showOverlay && (
          <div>
            <div
              onClick={this.clickOverlay}
              className={css.overlay}
              style={overlayStyle}
              ref={ref => this.updateElement('overlay', ref)}
            />
          </div>
        )}
        <div>
          <div
            className={css.main}
            style={style}
            id={id}
            onClick={onClick}
            ref={ref => this.updateElement('popup', ref)}
          >
            {children}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Popup.js